import { Controller } from "@hotwired/stimulus";

/**
 * お知らせ画面の詳細モーダルおよび自動ポップアップを管理するStimulusコントローラー
 *
 * 使用場所:
 * - お知らせ一覧画面（/notifications）の各お知らせ項目（クリックでモーダル開閉）
 * - トップページ（/）でのログイン顧客向け未読 targeted お知らせ自動ポップアップ
 *
 * 主な機能:
 * - お知らせ詳細モーダルの表示・非表示制御（クリックモーダル）
 * - 未読 targeted の順次ポップアップ（autoPopup ターゲット利用）
 * - 背景スクロール制御（モーダル表示時に無効化）
 *
 * 必要なターゲット要素:
 * - modal: クリックで開く既存の詳細モーダル要素（Turbo Stream で差し替えられる）
 * - autoPopup: 自動ポップアップ用のモーダル要素群（複数）
 */
export default class extends Controller {
  static targets = ["modal", "autoPopup"];
  static values = {
    autoShow: Boolean,
    currentIndex: { type: Number, default: 0 },
  };

  connect() {
    if (this.autoShowValue && this.hasAutoPopupTarget) {
      this.currentIndexValue = 0;
      this.renderAutoPopup();
      document.body.style.overflow = "hidden";
    }
  }

  // 既存: クリックモーダル表示
  show() {
    this.modalTarget.hidden = false;
    document.body.style.overflow = "hidden";
  }

  // 既存: クリックモーダル非表示
  hide() {
    this.modalTarget.hidden = true;
    document.body.style.overflow = "";
  }

  // 自動ポップアップ: 現在のインデックスのモーダルだけ表示し、それ以外は隠す
  renderAutoPopup() {
    this.autoPopupTargets.forEach((el, i) => {
      el.hidden = i !== this.currentIndexValue;
    });
  }

  // 自動ポップアップ: 「次へ進む / 閉じる」ボタンで次のお知らせへ。最後まで来たら全非表示
  advance() {
    const next = this.currentIndexValue + 1;
    if (next >= this.autoPopupTargets.length) {
      this.autoPopupTargets.forEach((el) => {
        el.hidden = true;
      });
      document.body.style.overflow = "";
    } else {
      this.currentIndexValue = next;
      this.renderAutoPopup();
    }
  }
}
